import { useCallback } from "react"
import type { SWRResponse } from "swr"
import { useRefValue } from "src/hooks"

export interface ItemWithId {
  id: unknown;
}

export function useSWRHandler<Item extends ItemWithId>(
  useSwrResponse: () => SWRResponse<Array<Item>>,
) {
  const {
    mutate,
    data,
  } = useSwrResponse()

  const dataRef = useRefValue(data)

  return useCallback(
    (newItem: Partial<Item>) => {
      const currentData = dataRef.current

      if (currentData) {
        const updatedList = currentData.map((item) => {
          if (item.id === newItem.id) {
            return {
              ...item,
              ...newItem,
            }
          }

          return item
        })

        void mutate(updatedList)
      } else {
        void mutate()
      }
    },
    [
      mutate,
      dataRef,
    ],
  )
}
